import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';

const blue = '#0d4efe';
const teal = '#01ebb2';
const ink = '#1a1a2e';
const muted = '#5a6478';
const notVariant = { shouldForwardProp: (prop) => prop !== '$variant' };

export const SearchBarRoot = styled(Box, notVariant)(({ $variant }) => ({
  width: '100%',
  maxWidth: $variant === 'hero' ? 760 : 720,
  margin: $variant === 'hero' ? 0 : '0 auto',
  textAlign: 'center',
}));

export const SearchHeading = styled('h2')({
  fontFamily: "'Plus Jakarta Sans', sans-serif",
  fontSize: '1.35rem',
  fontWeight: 700,
  letterSpacing: '-0.02em',
  color: ink,
  margin: '0 0 6px',
  '@media (max-width: 600px)': {
    fontSize: '1.15rem',
  },
});

export const SearchSubheading = styled('p')({
  fontSize: '0.95rem',
  color: muted,
  margin: '0 0 18px',
});

export const SearchFieldRow = styled(Box)({
  position: 'relative',
  textAlign: 'left',
});

export const SearchInput = styled(TextField, notVariant)(({ $variant }) =>
  $variant === 'hero'
    ? {
        '& .MuiOutlinedInput-root': {
          borderRadius: 999,
          background: '#ffffff',
          paddingLeft: '14px !important',
          paddingRight: '72px !important',
          fontSize: '1.1rem',
          boxShadow: '0 10px 28px rgba(13, 78, 254, 0.12)',
          '& fieldset': { borderColor: 'rgba(13, 78, 254, 0.14)' },
          '&:hover fieldset': { borderColor: 'rgba(13, 78, 254, 0.3)' },
          '&.Mui-focused fieldset': {
            borderColor: blue,
            borderWidth: 2,
          },
        },
        '& .MuiOutlinedInput-input': {
          padding: '20px 4px 20px 12px',
        },
        '@media (max-width: 600px)': {
          '& .MuiOutlinedInput-root': { fontSize: '1rem', paddingRight: '60px !important' },
          '& .MuiOutlinedInput-input': { padding: '15px 4px 15px 6px' },
        },
      }
    : {
        '& .MuiOutlinedInput-root': {
          borderRadius: 14,
          background: '#ffffff',
          paddingRight: '56px !important',
          fontSize: '1.05rem',
          boxShadow: '0 4px 18px rgba(13, 78, 254, 0.1)',
          '& fieldset': {
            borderColor: 'rgba(13, 78, 254, 0.22)',
            borderWidth: 1.5,
          },
          '&:hover fieldset': {
            borderColor: 'rgba(13, 78, 254, 0.4)',
          },
          '&.Mui-focused fieldset': {
            borderColor: blue,
            borderWidth: 2,
          },
        },
        '& .MuiOutlinedInput-input': {
          padding: '14px 4px 14px 8px',
        },
      },
);

export const SearchSubmitButton = styled(IconButton, notVariant)(({ $variant }) => {
  const isHero = $variant === 'hero';
  return {
    position: 'absolute',
    right: isHero ? 9 : 8,
    top: '50%',
    transform: 'translateY(-50%)',
    width: isHero ? 52 : 42,
    height: isHero ? 52 : 42,
    borderRadius: isHero ? '50%' : 10,
    color: '#ffffff',
    background: `linear-gradient(135deg, ${teal} 0%, ${blue} 100%)`,
    boxShadow: '0 4px 14px rgba(13, 78, 254, 0.35)',
    '& svg': { fontSize: isHero ? 28 : 24 },
    '&:hover': {
      background: `linear-gradient(135deg, ${teal} 0%, ${blue} 100%)`,
      filter: 'brightness(1.05)',
    },
    '@media (max-width: 600px)': isHero
      ? { width: 44, height: 44, right: 7, '& svg': { fontSize: 24 } }
      : {},
  };
});

export const SuggestionOption = styled('li')({
  display: 'flex !important',
  alignItems: 'center',
  gap: 10,
  padding: '10px 14px !important',
  '&.Mui-focused, &[aria-selected="true"]': {
    background: 'rgba(13, 78, 254, 0.07) !important',
  },
});

export const SuggestionLabel = styled('span')({
  fontWeight: 600,
  color: ink,
});

export const SuggestionTrade = styled('span')({
  color: muted,
  fontSize: '0.9rem',
});

export const SuggestionIcon = styled('span')({
  display: 'inline-flex',
  color: blue,
  '& svg': { fontSize: 20 },
});
